let filter1Frequency = 2910;
let filter1Gain = .1;
let filter1Q = 15;

let filter2Frequency = 1701;
let filter2Gain = .5;
let filter2Q = 15;

function logByteArray(bytes)
{
  var reader = new FileReader();
  reader.readAsDataURL(bytes);
  reader.onloadend = function() {
    var base64data = reader.result;
    console.log(base64data);
  }
}

class VoiceV2 {
  // No-op stubs to match v3 API surface (called from webradio.js)
  setAlias(_alias) { /* v2: no-op */ }
  setAccessibilityListenersPresent(_value) { /* v2: no-op */ }

  ambe = true;
  cbVoiceMetadata = undefined;
  audioContext = new (window.AudioContext || window.webkitAudioContext)({
    sampleRate:48000,latencyHint:"interactive"
  });
  filter1 = this.audioContext.createBiquadFilter();
  filter2 = this.audioContext.createBiquadFilter();
  compressor = this.audioContext.createDynamicsCompressor();
  gainNode = this.audioContext.createGain();
  queuedPackets= []
  alive = false;
  currentChannel = undefined;
  recorder = undefined;
  socket = undefined;
  pttDown = false;
  playing = false;
  lastPacket = false;
  currentVolume = 1;
  voiceSubID = undefined;
  audioDest = undefined;
  audio = undefined;
  setAudioDevice(device) {
    console.debug("Set audio device")
    console.debug(device)
    if(device === null)
    {
      this.audioDest = undefined;
      this.audio = undefined;
    }
    else
    {
      this.audio = new Audio();
      this.audio.setSinkId(device.deviceId)
      this.audioDest = this.audioContext.destination;
      this.audio.src = this.audioDest.src;
    }
  };
  onData(data) {
    if(!this.pttDown)
    {
      this.lastPacket = false;
    }
    try {
      if (this.pttDown || !this.lastPacket) {
        if(!this.pttDown && !this.lastPacket)
        {
          console.info("Sending last voice packet")
          this.lastPacket = true;
        }
        if(this.pttDown)
        {
          this.lastPacket = false;
        }
        if (this.currentChannel != undefined) {
          console.debug("[VOICE] Sending voice data packet...")
          let voicePacket = {};
          voicePacket.metadata = {};
          if(this.voiceSubID!=undefined) {
            voicePacket.metadata.subscriberID = this.voiceSubID;
          }
          voicePacket.metadata.enhancedVoice = true;
          voicePacket.metadata.packetLength = 240;
          voicePacket.packet = data;
          this.socket.emit("v2_packet", this.currentChannel, voicePacket);
        } else {
        }
      } else {
      }
    }
    catch(e)
    {
      console.error("Error sending message")
      console.error(e)
    }
  }
  playSinglePacket(packet)
  {
    console.debug("[VOICETICK]Play single packet")
    let source = this.audioContext.createBufferSource();
    source.buffer = packet.buffer;
    source.connect(this.gainNode)
    if(this.audioDest!==undefined)
    {
      this.gainNode.connect(this.audioDest);
    }
    else
    {
      this.gainNode.connect(this.audioContext.destination);
    }
    source.start();
    source.onended = ()=>{
      if(this.queuedPackets.length>0)
        this.playSinglePacket(this.queuedPackets.shift())
      else
        this.playing = false;
    };
  }

  setSubscriber(subscriberID)
  {
    this.voiceSubID = subscriberID;
  }
  constructor(socket)
  {
    setInterval(()=>{
      if(this.playing === false) {
        if (this.queuedPackets.length > 0) {
          console.debug("[VOICETICK]Start playing voice packets")
          this.playing = true;
          let packet = this.queuedPackets.shift();
          setTimeout(() => {
            console.debug("[VOICETICK]Play first packet now")
            this.playSinglePacket(packet)
          }, 500);
        }
      }
    },5)
    this.socket = socket;
    console.info("[VOICE] Init voice...")
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.recorder = new MediaRecorder(stream,{
        mimeType: "audio/webm;codecs:vorbis"
      });
      this.recorder.ondataavailable = e => {
        this.onData(e.data);
      }
    });
    this.socket.on("v2_packet",d=>{
      this.handleV2Packet(d).then();
    })

    this.gainNode.gain.value = this.currentVolume/1.5;
  }
  // No-op stub. v2 carries the encryption key inside the channel name string
  // itself (`vc[systemID:channelID$encryptionKey]`) — that's the legacy access
  // control mechanism. Provided so unconditional callers don't break under v2.
  setEncryptionKey(_channelString, _keyString) { /* no-op for legacy v2 path */ }

  setVoiceChannel(newChannel)
  {
      if(this.currentChannel!==undefined)
    {
      this.socket.emit("vc_leave",this.currentChannel);
      this.currentChannel=undefined;
    }
    if(newChannel != undefined)
    {
      this.pttDown = false;
      this.currentChannel = "vc["+newChannel+"]";
      this.socket.emit("vc_join",this.currentChannel)
    }
  }
  queuePacketForPlay(voicePacket){
    console.debug("[VOICE] queue voice packet, spot "+(this.queuedPackets.length+1)+" in queue")
    this.queuedPackets.push(voicePacket)
  }
  async handleV2Packet(CAIVoicePacket)
  {
    try {
      let packet;

      try{
        if(this.cbVoiceMetadata!=undefined && this.cbVoiceMetadata!=null && CAIVoicePacket.metadata != undefined) {
          this.cbVoiceMetadata(CAIVoicePacket.metadata);
        }
      }
      catch{
        //
      }
      if(this.ambe && CAIVoicePacket.ambePacket!=undefined)
      {
        packet = CAIVoicePacket.ambePacket;
      }
      else if(CAIVoicePacket.packet!=undefined)
      {
        packet = CAIVoicePacket.packet;
      }
      else
      {
        packet = CAIVoicePacket;
      }
      let result = await this.audioContext.decodeAudioData(packet);
      this.queuePacketForPlay({
        buffer:result,
        duration:result.duration
      });

    }
    catch(e)
    {

    }
  }
  leaveVoiceChannel()
  {
    this.setVoiceChannel(null)
  }
  setPTT(pttValue) {
    this.pttDown = pttValue;
    if(pttValue)
    {
      this.recorder.start();
      var recordPTT = setInterval(()=>{
        if(this.pttDown)
        {
          this.recorder.stop();
          this.recorder.start();
        }
        else
          clearInterval(recordPTT);
      },240)
    }
    else
    {
      try {
        this.recorder.stop();
      }
      catch(e)
      {
        console.log("failed to stop media")
      }
    }
  }
};

// Expose as global for the voice.js router
if (typeof window !== "undefined") { window.VoiceV2 = VoiceV2; }
